import * as types from "./monev.actionTypes";
import { action, createAsyncAction } from "typesafe-actions";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { Monev, Penyelenggara, Peserta } from "../../interfaces/Monev";
import { MonevListRequest, MonevCreateResponse, MonevListResponse, MonevUpdateResponse, MonevDokumenRequest, MonevDokumenResponse, MonevDetailRequest, MonevDetailResponse } from "./types";
import { DokumenKerjasama } from "../../interfaces/DokumenKerjasama";
import moment from "moment";
import { EditorValue } from "react-rte";

export const selectMonev = (monev: Monev | null) => action(types.SELECT_MONEV, { monev });

export const selectDokumenKerjasama = (dokumenKerjasama: DokumenKerjasama | null) => action(types.SELECT_DOKUMEN_KERJASAMA, { dokumenKerjasama });

export const updateNamaKegiatan = (value: string) => action(types.UPDATE_NAMA_KEGIATAN, { value });
export const updateLokasi = (value: string) => action(types.UPDATE_LOKASI, { value });
export const updateTanggalMulai = (value: string) => action(types.UPDATE_TANGGAL_MULAI, { value });
export const updateTanggalSelesai = (value: string) => action(types.UPDATE_TANGGAL_SELESAI, { value });
export const updateDeskripsi = (value: EditorValue) => action(types.UPDATE_DESKRIPSI, { value });
export const updateEvaluasi = (value: EditorValue) => action(types.UPDATE_EVALUASI, { value });
export const updateTautan = (value: string) => action(types.UPDATE_TAUTAN, { value });
export const updateFile = (file: File | null) => action(types.UPDATE_FILE, { file });
export const updateDokId = (value: number) => action(types.UPDATE_DOK_ID, { value });
export const deleteFile = () => action(types.DELETE_FILE, {});

export const updatePenyelenggara = (value: Penyelenggara[]) => action(types.UPDATE_PENYELENGGARA, { value });
export const updatePeserta = (value: Peserta[]) => action(types.UPDATE_PESERTA, { value });
export const updateDeskripsiPeserta = (value: string) => action(types.UPDATE_DESKRIPSI_PESERTA, { value });

export const updateFileInputPeserta = (value: string) => action(types.UPDATE_FILE_INPUT_PESERTA, { value });

export const initializeCreateMonev = (idDokumen: number) => {
  const tanggalSelesai = new Date();
  tanggalSelesai.setDate(tanggalSelesai.getDate() + 1);
  const monev: Monev | null = {
    MONEV_ID: -1,
    DOK_ID: idDokumen,
    NAMA_KEGIATAN: '',
    LOKASI_KEGIATAN: '',
    TANGGAL_MULAI_KEGIATAN: moment(new Date()).format('YYYY-MM-DD'),
    TANGGAL_SELESAI_KEGIATAN: moment(tanggalSelesai).format('YYYY-MM-DD'),
    DESCR_KEGIATAN: '',
    EVALUASI_KEGIATAN: '',
    FILE_KEGIATAN: '',
    LINK_DOKUMENTASI_KEGIATAN: '',
    PESERTA_KEGIATAN: '',
    PENYELENGGARA_DETAIL: [],
    PESERTA_DETAIL: [],
    DOK_DETAIL: null
  }

  return action(types.INITIALIZE_CREATE_MONEV, { monev })
}

export const getMonevAsync = createAsyncAction(
  types.GET_MONEV_REQUEST,
  types.GET_MONEV_SUCCESS,
  types.GET_MONEV_FAILURE
)<MonevListRequest, MonevListResponse, ErrorResponse>();

export const getDokumenAsync = createAsyncAction(
  types.GET_DOKUMEN_REQUEST,
  types.GET_DOKUMEN_SUCCESS,
  types.GET_DOKUMEN_FAILURE
)<MonevDokumenRequest, MonevDokumenResponse, ErrorResponse>();

export const updateMonevAsync = createAsyncAction(
  types.UPDATE_MONEV_REQUEST,
  types.UPDATE_MONEV_SUCCESS,
  types.UPDATE_MONEV_FAILURE
)<Monev, MonevUpdateResponse, ErrorResponse>();

export const createMonevAsync = createAsyncAction(
  types.CREATE_MONEV_REQUEST,
  types.CREATE_MONEV_SUCCESS,
  types.CREATE_MONEV_FAILURE
)<Monev, MonevCreateResponse, ErrorResponse>();

export const getDetailAsync = createAsyncAction(
  types.GET_DETAIL_REQUEST,
  types.GET_DETAIL_SUCCESS,
  types.GET_DETAIL_FAILURE
)<MonevDetailRequest, MonevDetailResponse, ErrorResponse>();
